export default "__VITE_ASSET__CUPlcxbM__"